<template>
  <section class="table-wrap">
    <header>
      <h4>Descontos</h4>
    </header>
    <div class="filter">
      <input-control v-model="query" @keyup="search" placeholder="Buscar..." @onsearch="search" search preventSearchButton></input-control>
      <a href="#" class="btn btn-secondary" @click.prevent="clearSearch">
        Limpar
      </a>
      <div>
        <switch-control v-model:checked="active" labelOn="Apenas Ativos" labelOff="Todos" @change="toggleDisabled" invert></switch-control>
      </div>
    </div>
    <table v-if="descontos" class="transparent-table ">
      <thead>
        <tr>
          <th>ID</th>
          <th>Descrição</th>
          <th>Sigla</th>
          <!-- <th>Parcelas Carência</th> -->
          <th>Percentual Padrão</th>
          <th>Desconto Somativo</th>
          <th>Desconto Plano</th>
          <th>Progride de Ciclo</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(desconto,i) in descontos" :key="desconto">
          <td>
            {{ desconto.idTipoDesconto }}
          </td>
          <td>
            {{ desconto.descricao }}
          </td>
          <td>
            {{ desconto.sigla }}
          </td>
          <!-- <td>
            {{ desconto.parcelascarencia }}
          </td> -->
          <td>
            {{ desconto.percentualPadrao }}
          </td>
          <td class="form-group">
            <!-- {{ desconto.descontoSomativo ? 'Sim' : 'Não' }} -->
            <div class="switchWrapMiniLoose">
              <switch-control v-model:checked="desconto.descontoSomativo" labelOn="Sim" labelOff="Não" @change="toggleChange(i)" invert></switch-control>
            </div>
          </td>
          <td>
            {{ desconto.descontoPlano ? 'Sim' : 'Não' }}
          </td>
          <td class="form-group">
            <div class="switchWrapMiniLoose">
              <switch-control v-model:checked="desconto.proximoCiclo" labelOn="Sim" labelOff="Não" @change="toggleChange(i)" invert></switch-control>
            </div>
          </td>
          <td>
            {{ desconto.ativo ? 'Ativo' : 'Inativo' }}
          </td>
          <td class="text-right">
            <label class="check-control">
              <input type="checkbox" class="check" v-model="desconto.selected">
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <footer class="action-wrap">
      <a href="#" @click.prevent="saveDescontos()" class="btn btn-primary">
        Salvar
      </a>
      <a href="#" @click.prevent="cancel()" class="btn btn-secondary">
        Voltar
      </a>
    </footer>
  </section>
</template>

<script>
import FinanceiroService from '@/services/financeiro.service.js'

export default {
  data () {
    return {
      descontos: null,
      bkp: null,
      query: null,
      active: false
    }
  },
  mounted () {
    this.getDescontos()
  },
  methods: {
    cancel () {
      this.$emit('onCancel')
    },
    toggleChange ( index ) {
      this.descontos[index].selected = true
    }, 
    getDescontos () {
      window.spinner.emit('open')
      FinanceiroService.getDescontos().then(
        response => {
          console.log("response:", response)
          if ( response.data.length > 0 ) {
            this.descontos = response.data
            this.bkp = Object.assign([], response.data)
            this.addSelector(true)
          } else {
            window.toaster.emit('open', {style: "error", message: "Não foi possível recuperar os descontos. Isto parece ser um problema de integração com o GestorClass.", floater: true})
          }
          
          window.spinner.emit('close')
        },
        () => {
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Não foi possível recuperar os descontos.", floater: true})
          window.spinner.emit('close')
        }
      )
    },
    addSelector ( off ) {
      this.descontos.map( k => {
        k.selected = off ? false : true
      })
    },
    search () {
      if ( this.query && this.query.length > 0 ) {
        const result = this.bkp.filter( k => {
          // console.log("k:", k.descricao)
          const query = this.query.toLowerCase()
          const descricao = k.descricao ? k.descricao.toLowerCase() : ""
          const sigla = k.sigla ? k.sigla.toLowerCase() : ""
          const id = k.idTipoDesconto.toString()

          return descricao.includes(query) || sigla.includes(query) || id.includes(query)
        })

        this.descontos = result
      } else if ( !this.query || this.query.length == 0 ) {
        this.clearSearch()
      }
    },
    clearSearch () {
      this.descontos = Object.assign([],this.bkp)
      this.query = null
    }, 
    toggleDisabled () {
      this.descontos = this.active ? this.bkp.filter(a => a.ativo) : Object.assign([],this.bkp)
    },
    saveDescontos () {
      const data = this.descontos.filter( k => k.selected )
      data.map( k => {
        k.proximoCiclo = k.proximoCiclo ? 1 : 0,
        k.descontoSomativo = k.descontoSomativo ? 1 : 0
        delete k.selected
      })

      console.log("saveDescontos:", data)
      if ( data.length > 0 ) {
        window.spinner.emit('open')
        FinanceiroService.saveDescontos( data ).then(
          response => {
            if ( response.status == 200 ) {
              window.toaster.emit('open', {style: "success", message: "Arrecadações salvas com sucesso.", floater: true})
            } else {
              window.toaster.emit('open', {style: "error", message: "Não foi possível salvar as arrecadações. Isto parece ser um problema de integração com o GestorClass.", floater: true})
            }

            window.spinner.emit('close')
          },
          () => {
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Não foi possível salvar as arrecadações.", floater: true})
            window.spinner.emit('close')
          }
        )
      } else {
        window.toaster.emit('open', {style: "error", message: "Nenhum item selecionado para salvar.", floater: true})
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-wrap {
    padding: $hmg $hmg_small $mg_extra;

    header {
      padding: 0 $hmg_small
    }
  }
  
  .action-wrap {
    display: flex; align-content: center; align-items: center;
    justify-content: flex-start;
    padding: $hmg 0;

    a {
      margin-right: $hmg_small
    }

    label{
      margin-right: $hmg
    }
  }

  .filter {
    display: flex; align-content: center; align-items: center;
    justify-content: flex-start; gap: $hmg_small;
    padding: $hmg_small 0; margin-bottom: $hmg_small;
    .icon {
      margin-right: $hmg_small
    }
    .input-control {
      width: 250px;
    }
    // .btn {
    //   margin-left: $hmg_small
    // }
  }
</style>